import Vue from 'vue'

Vue.filter('phoneRuFormatting', phone => {
  let regExp = /(...)(...)(..)(..)/
  let phoneReg = regExp.exec(phone)
  if (phoneReg && phoneReg.length === 5) {
    let formatted = '+7'
    formatted += ' (' + phoneReg[1] + ')'
    formatted += ' ' + phoneReg[2]
    formatted += '-' + phoneReg[3] + '-'
    formatted += phoneReg[4]

    return formatted
  }
  return phone
})



// WEBPACK FOOTER //
// ./src/filters/index.js